import { jsx as r } from "react/jsx-runtime";
import "react";
var C = (o) => /* @__PURE__ */ r("svg", {
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ r("path", {
    d: "M12.612 3.83103L6.24159 10.175L3.39008 7.33531C3.02139 6.96815 2.42402 6.96815 2.05533 7.33531C1.68664 7.70247 1.68664 8.29736 2.05533 8.66452L5.57421 12.1688C5.75778 12.3516 6.00046 12.4446 6.24159 12.4446C6.48271 12.4446 6.72384 12.3532 6.90896 12.1688L13.9467 5.16024C14.3154 4.79308 14.3154 4.19819 13.9467 3.83103C13.578 3.46387 12.9807 3.46387 12.612 3.83103Z",
    fill: "currentColor"
  })
});
export {
  C as default
};
